export default __webpack_public_path__ + "static/media/texturahome.b702954e.svg";